// extracted by mini-css-extract-plugin
export default {"form-radio":"Banking_form-radio__J3X9B","name":"Banking_name__8Ma09","warning":"Banking_warning__3Z0u4","pay-success":"Banking_pay-success__Vc7qT"};